import { z } from "zod";

export const preMediaPropositionFileFormSchema = z.object({
  fileSignedId: z.string().optional(),
});

export type PreMediaPropositionFileFormSchema = z.infer<
  typeof preMediaPropositionFileFormSchema
>;
